<template>
  <div class="boooking-short-card">
    <div class="booking-map">
      <slot name='image'></slot>
    </div>
    <div class="booking-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BookingShortItemLayout',
};
</script>

<style lang="scss" scoped>

  $card-background-color: #fff;
  $card-font-size: 16px;
  $card-border-radius: 8px;
  $card-box-shadow: 0 4px 16px 0 rgba(55, 63, 71, 0.05);
  $content-height: 240px;
  $card-desktop-min-width: 748px;


  .boooking-short-card {
    font-size: $card-font-size;
    padding: 1em;
    background-color: $card-background-color;
    box-shadow: $card-box-shadow;
    border-radius: $card-border-radius;
    box-sizing: border-box;
    display: flex;
    min-width: $card-desktop-min-width;
    @include media-breakpoint-down(sm) {
      min-width: 560px;
      padding: 0px;
    }
    @include media-breakpoint-down(xs) {
      min-width: unset;
      padding: 0px;
    }
  }

  .booking-map, .booking-map {
    border: 1px;
  }

  .booking-map {
    border-radius: $card-border-radius;
    flex-basis: $content-height;
    // height: $content-height;
    background-color: azure;
    flex-shrink: 0;
    display: none;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    @include media-breakpoint-down(md) {
      display: none;
      height: auto;
    }
  }

  .booking-content {
    flex-grow: 1;
    width: 100%;
    // background-color: cornsilk;
    // padding: 8px 8px 8px 32px;
    padding: 8px 8px 8px 8px;
    @include media-breakpoint-down(md) {
      padding-left: 8px;
    }
    @include media-breakpoint-down(sm) {
      border-radius: $card-border-radius;
      padding: 16px 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/BookingList/components/BookingShortItemLayout.vue